// Dependencies
import VueRouter from 'vue-router'

// Components
import Home from './layouts/Home/Home'
import Login from './layouts/Login/Login'
import NotFound from './layouts/NotFound/NotFound'

const router = new VueRouter({
  mode: 'history',
  routes: [
    { path: '/', name: 'home', component: Home, isDefault: true },
    { path: '/login', name: 'login', component: Login },
    { path: '/not-found', name: '404', component: NotFound },
    { path: '*', redirect: '/not-found' }
  ]
})

export { VueRouter, router }



// WEBPACK FOOTER //
// ./src/router.js